import type {RutaProd} from '../../../../runtime/rutas';
export default {
  "ruta": "/sistema/registro/confirmar/{token}",
  "alias": [],
  "documento": "raiz",
  "acceso": "publico",
  "filas": [
    "156"
  ],
  "cita": "Controllers/AccountController.cs"
} satisfies RutaProd;
